import { components, MultiValueProps } from "react-select";
import { SelectOption } from "./types";
import AdditionalOptionsPill from "./AdditionalOptionsPill";

interface CustomMultiValueProps extends MultiValueProps<SelectOption> {
  selectedOptionsToShow: number;
}

const CustomMultiValue = ({ index, getValue, selectedOptionsToShow, ...props }: CustomMultiValueProps) => {
  const allOptionsSelected: boolean = getValue().some((item: SelectOption) => item.value === " ");
  const optionsToShow =  allOptionsSelected ? 0 : selectedOptionsToShow;
  const additionalSelectedOptions = getValue()
    .slice(optionsToShow)
    .map((x) => x.label);

  if(index < optionsToShow) {
    return <components.MultiValue {...props} index={index} getValue={getValue} />;
  } 
  
  if(index === optionsToShow) {
    return allOptionsSelected ? 
      <components.MultiValue {...props} index={index} getValue={getValue} /> : 
      (<AdditionalOptionsPill items={additionalSelectedOptions} />);
  }

  return null;
};

export default CustomMultiValue;
